import React from 'react';
import { Package } from 'lucide-react';

// Product thumbnail with graceful fallback (Phase 14.3).
// Used in the orders table (40×40) and the OrderDetailSheet (120×120).
// - Broken/absent images fall back to a neutral #F5F5F5 tile with a discreet
//   Package outline icon — same visual language as ProductImage.jsx on
//   /produits, minus the indigo wash (this variant is meant to sit inline
//   with dense tabular data or the sheet, so we keep it quiet).
// - `loading="lazy"` on the image itself — necessary for the table where 25
//   rows × 1 image could otherwise fire simultaneously on first paint.
export default function ProductThumb({ src, alt = '', size = 'sm' }) {
    const [broken, setBroken] = React.useState(false);
    const showImg = !!src && !broken;

    // Phase 14.3.1: "lg" size reduced from 120→96 to give more horizontal
    // room to the product info column inside the 420 px order-detail sheet.
    // The 40 px "sm" size (used in the /commandes table) is untouched.
    const dim = size === 'lg'
        ? { box: 'w-24 h-24',            radius: 'rounded-lg', icon: 30 }
        : { box: 'w-10 h-10',            radius: 'rounded-md', icon: 18 };

    const base = `${dim.box} ${dim.radius} flex-shrink-0 border border-[#E5E7EB] bg-[#F5F5F5]`;

    if (showImg) {
        return (
            <img
                src={src}
                alt={alt || ''}
                onError={() => setBroken(true)}
                loading="lazy"
                draggable={false}
                data-testid={`product-thumb-${size}`}
                className={`${base} object-cover`}
            />
        );
    }

    return (
        <div
            data-testid={`product-thumb-${size}-fallback`}
            role="img"
            aria-label={alt || 'Image du produit indisponible'}
            className={`${base} flex items-center justify-center text-[#9CA3AF]`}
        >
            <Package size={dim.icon} strokeWidth={1.5} />
        </div>
    );
}
